import React from "react";
import { Link } from "react-router-dom";
import Crypto from "crypto";

class Asymmetric extends React.Component {
  getKeyPair() {
    /*let { publicKey, privateKey } = Crypto.generateKeyPairSync("rsa", {
      modulusLength: 2048,
      publicKeyEncoding: {
        type: "spki",
        format: "pem",
      },
      privateKeyEncoding: {
        type: "pkcs8",
        format: "pem",
        cipher: "aes-256-cbc",
        passphrase: "top secret",
      },
    });

    const data = "my secret data";

    const encryptedData = Crypto.publicEncrypt(
      {
        key: publicKey,
        padding: Crypto.constants.RSA_PKCS1_OAEP_PADDING,
        oaepHash: "sha256",
      },
      // We convert the data string to a buffer using `Buffer.from`
      Buffer.from(data)
    );

    // The encrypted data is in the form of bytes, so we print it in base64 format
    // so that it's displayed in a more readable form
    console.log("encypted data: ", encryptedData.toString("base64"));*/
    console.log(Crypto.getCiphers())
    console.log(Crypto.getHashes())
  }

  renderSelectedTab() {
    return (
      <div className="ui bottom attached active tab segment">
        Asymmetric Form
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="ui top attached tabular menu">
          <div className="item">
            <i className={"key icon"} />
            <Link to={"/symmetric"}>Symmetric Encryption</Link>
          </div>

          <div className="active item">
            <i className={"key icon"} />
            <Link to={"/asymmetric"}>Asymmetric Encryption</Link>
          </div>

          <div className="item">
            <i className={"pencil alternate icon"} />
            <Link to={"/signature"}>Signature</Link>
          </div>

          <div className="item">
            <i className={"hashtag icon"} />
            <Link to={"/hashing"}>Hashing</Link>
          </div>
        </div>

        {this.renderSelectedTab()}

        {this.getKeyPair()}
      </div>
    );
  }
}

export default Asymmetric;
